import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class ConnectivityService {
  private suppressToasts = true;
  private onlineStatusSubject = new BehaviorSubject<boolean>(navigator.onLine);
  public onlineStatus$: Observable<boolean> = this.onlineStatusSubject.asObservable();

  constructor(private toast: ToastService) {
    // Suppress toasts for the first 2 seconds to avoid refresh "jitters"
    setTimeout(() => {
      this.suppressToasts = false;
    }, 2000);

    merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    ).subscribe((status: boolean) => {
      if (!this.suppressToasts) {
        if (status === false && this.onlineStatusSubject.value !== false) {
          this.toast.show('error', "No Internet Connection: Please check your network and try again.");
        } else if (status === true && this.onlineStatusSubject.value === false) {
          this.toast.show('success', "Back Online: Your internet connection has been restored.");
        }
      }
      this.onlineStatusSubject.next(status);
    });
  }

  get isOnline(): boolean {
    return this.onlineStatusSubject.value;
  }
}
